<template>
  <div id="app"
    v-loading="$store.state.loading"
    element-loading-text="加载中，请稍候..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
  >
    <router-view/>
  </div>
</template>

<script>
  import {commonConstant} from '@/utils/Constants';
  import commonUtil from '@/utils/commonUtil';

  export default {
    name: 'App',
    data() {
      return {

      };
    },
    created() {
      this.autoLogin();
    },
    methods:{
      // 自动登录
      autoLogin(){
        if(commonUtil.getLoginToken()){
          this.$store.state.loading = true;
          this.$router.push("/home");
        }
      },
    }
  }
</script>

<style>
  html,body,#app{
    height: 100%;
  }
  body{
    margin: 0;
    background: url("assets/images/bg.jpg") no-repeat;
    background-size: cover;
  }
  /* notify样式 */
  .notifyCustomClass{
    width: auto !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue